<template>
	<div>
        <page-header image="header2.jpg" title="Übersichtskarte"></page-header>
		<b-container class="container">
				<b-row>
					<b-col>
							<p>
								Die Weinprobe ist auf vier verschiedene Stände aufgeteilt, die sich bequem zu Fuss erreichen lassen.
							</p>
							<div class="map-container">
								<img id="staendeKarte" src="../assets/map/weinprobe-karte.png" alt="Karte"
								usemap="#staende">
								<map name="staende">
									<area shape="circle" coords="304,367,12" href="Stand1"
									alt="Stand 1">
									<area shape="circle" coords="104,251,12" href="Stand2"
									alt="Stand 2">
									<area shape="circle" coords="202,225,12" href="Stand3"
									alt="Stand 3">
									<area shape="circle" coords="324,252,12" href="Stand4"
									alt="Stand 4">
								</map>
							</div>
					</b-col>
				</b-row>
			</b-container>
	</div>
</template>

<script>
// @ is an alias to /src

import PageHeader from '@/components/PageHeader.vue';
export default {
  name: 'areaMap',
  components: {
    PageHeader
  }
}
</script>

<style scoped lang="scss">
	.map-container {
		width: 100%;
	}

	.map-container img {
		width: 100%;
		max-width: 527px;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}
	
	.header {
        height: 20em;
        text-align: center;
        background: url(../assets/images/header2.jpg) no-repeat center center; 
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        position: relative;
    }

    .header-title {     
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 100%;
        background-color: rgba(255, 255, 255, 0.15);
    }

	@include md {
        .header-title h1 {
			font-size: 6rem;
		}
    }
</style>
